module.exports = __webpack_public_path__ + "img/logo.685bd552.svg";